import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import { _longPressTypes, LongPressWrapper } from 'global/wrappers/LongPressWrapper';
import _ from 'lodash';
import { useContext, useEffect, useState } from 'react';
import { Breadcrumb, Button, Icon, Label, Portal } from 'semantic-ui-react';
import { FrameworkContext } from '../cnr/contexts/FrameworkContent';
import { HeaderContext } from '../cnr/contexts/HeaderContext';
import { PapsContext } from '../cnr/contexts/PapsContext';
import { ParentContext } from '../cnr/contexts/ParentContext';
import { PreviewContext } from '../cnr/contexts/PreviewContext';
import { uniqueKey } from '../common/keys';
import { appIconTypes } from '../enums/appIconTypes';
import { gEnums } from '../enums/globalEnums';
import UiAppUserAction from '../pageItem/modification/userActions/UiAppUserAction';
import { currentHelpers } from '../redirection/current';
import TopMenuIcons from './TopMenuIcons';

// https://codepen.io/gpsn/pen/PPqrZw

/** PageTopHeader`.  
 * @description Returns a menu component for the app.
 */
const PageTopHeader = () => {

  // mywebsite.com/clients/clientKey/events/eventKey/landing
  const parentContext = useContext(ParentContext);
  const { states, handlers } = parentContext ?? {}
  const { appSettings_state, currentSettings_state, page_state, paps_state, startData_state, appNotifications_state } = states
  const { pushPayload, showPayload } = appNotifications_state ?? {}
  const { aps_global, aps_styles, aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});
  const { aps_page } = _.get(page_state, 'pageSettings', {});
  const { display: display_global } = aps_global ?? {}
  const { showPageTypeBreadcrumb: showPageTypeBreadcrumb_g } = display_global ?? {}
  const { appUser_handlers, appNotifications_handlers } = handlers
  const { settingsSourceType } = currentSettings_state ?? {}

  const { appConfigSettings } = appSettings_state ?? {}
  const { appNames } = appConfigSettings ?? {}
  const { appNameSc } = appNames ?? {}

  const { allowFavorites, favoriteCollections } = aps_appUserSettings ?? {}

  // authContext  
  const appUserAccess = useAppUserAccess()
  const { loggedIn, favs_info } = appUserAccess ?? {}
  const { eventFavs } = favs_info ?? {};

  // previewContext
  const previewContext = useContext(PreviewContext)
  const { preview_state } = previewContext ?? {}
  const { settingsPreviewHasChanged } = preview_state ?? {}

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state, framework_handlers } = frameworkContext ?? {}
  const { isMobileDevice } = framework_state ?? {}

  const { pageDatas } = startData_state ?? {}

  // papsContext
  const papsContext = useContext(PapsContext);
  const { navigate } = papsContext ?? {}
  const { otherView, view, viewKey, pathViews, isHomePage, pathName } = paps_state

  // headerContext
  const headerContext = useContext(HeaderContext)
  const { header_state } = headerContext ?? {}
  const { appCaptions, itemCount, allowItemLinking, actionCaption, itemLinked, headerFontSizes } = header_state ?? {}
  const { main: caption_main, sub: caption_sub, year: caption_year } = appCaptions ?? {}

  // main PAGE caption
  const { menu: menu_page } = aps_page ?? {}
  const { showPageTypeBreadcrumb, showParentBreadcrumbs } = menu_page ?? {}

  const _showFavorite = viewKey && allowFavorites && favoriteCollections && favoriteCollections.includes(view)

  // DATA caption
  const { pageDataCaption } = page_state ?? {}

  // local state   
  const [fontSizes, setFontSizes] = useState({ title: 1, subTitle: .8, hideSubTitle: false })

  const [showAction, setShowAction] = useState()
  const [_main, set_main] = useState()
  const [_sub, set_sub] = useState()
  const [_year, set_year] = useState()

  const isPageFav = eventFavs && eventFavs[view] && eventFavs[view][viewKey] ? true : false

  useEffect(() => {
    if (isHomePage) {
      set_main(_.startCase(appNameSc) + ' ' + caption_main)
    } else {
      if (caption_main === 'Events') {
        set_main(_.startCase(view))
      } else {
        set_main(caption_main)
      }
    }

    set_year(pathViews.sports ? caption_year : null)
    set_sub(caption_sub)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [view, viewKey, caption_main, caption_sub, caption_year, settingsPreviewHasChanged]);

  useEffect(() => {
    if (headerFontSizes) {
      setFontSizes(headerFontSizes)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [headerFontSizes]);

  useEffect(() => {
    if (pushPayload) {
      appNotifications_handlers.handleShow_payload()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [pushPayload]);

  const topSac = aps_styles ? aps_styles[gEnums.projectStyles.topMenu] : {}

  let { className, style } = topSac ?? {}

  if (isMobileDevice) {
    className += ' imd'
  }

  const p = {}
  const { myNotificationsU } = p

  if (style && !style.backgroundColor) { className = 'bc-main' }
  className += ' tmh'

  const handleShowAction = () => setShowAction(!showAction)

  const handlePageFavorite = () => {
    const favItem = {
      [view]: {
        [viewKey]: {
          name: _main ? _main : pageDataCaption,
          pathName: pathName
        }
      }
    }
    appUser_handlers.handleAmmend_pageFavorite(paps_state, _main, favItem)
  }

  const match_div = (match, cn) => {
    const _match = JSON.parse(match)
    const mis = _.map(_match, (mi, mik) => (
      <div className={cn + '-' + mik}>{mi}</div>
    ))
    return <div className={cn}>{mis}</div>
  }

  const seg_payload = () => {
    const { url, status, data } = pushPayload ?? {}
    const { title, body, cn, match } = data ?? {}
    return <Portal onClose={appNotifications_handlers.handleClose_payload} open={true}>
      <div className={'seg-payload'}       >
        <div color='white'><Icon size='large' name={'bell'} />{title}</div>
        <div style={{ padding: '1em' }}>
          <p>{body}</p>
          <p>{url}</p>
          {match && match_div(match, cn)}
          <p>{status}</p>
          <Button
            size='small'
            content='Close'
            floated='right'
            onClick={appNotifications_handlers.handleClose_payload}
          />
        </div>
      </div>
    </Portal>
  }

  const breadcrumbs = () => {
    let bcrs = []
    if (view !== 'landing' && (showPageTypeBreadcrumb || (viewKey && showPageTypeBreadcrumb_g))) { bcrs.push({ key: view, content: _.startCase(view), link: false }) }
    if (showParentBreadcrumbs && pageDatas) {
      if (pathViews) {
        Object.keys(pathViews).forEach(pv => {
          if (pageDatas[pv] && pv !== view) {
            bcrs.push({ key: pageDatas[pv], content: pageDatas[pv], link: false })
          }
        })
      }
    }
    return bcrs && bcrs.length > 0 && <Breadcrumb className={'item-breadcrumb'} icon='right angle' sections={bcrs} style={{ fontSize: fontSizes.subTitle + 'rem', display: fontSizes.hideSubTitle ? 'none' : null }} />
  }

  const miSidebar = () => {
    if (myNotificationsU && myNotificationsU.length > 0) {
      return <div className={'tmh-sidebar'} key={uniqueKey('pth', 'n')} onClick={() => framework_handlers ? framework_handlers.handleShow_appSidebar() : null} >
        <Icon.Group>
          <Icon name={appIconTypes.content} />y
          <Icon corner name={appIconTypes.add} size='large' color='red' />
        </Icon.Group>
      </div>
    } else {
      return <div key={uniqueKey('pth', 'n')}
        className={'tmh-sidebar'}
        onClick={() => framework_handlers ? framework_handlers.handleShow_appSidebar() : null} >
        <Icon name={settingsSourceType === 'reg' ? appIconTypes.options : appIconTypes.content} />
      </div>
    }
  }

  const miBackOrLogo = () => <div
    key={uniqueKey('pth', 'mi', 'b')}
    className={'tmh-back'}
    onClick={() => { currentHelpers.pushBack(navigate) }}>
    <Icon name={appIconTypes.arrowLeft} />
  </div>


  const miFavorite = () => <div
    key={uniqueKey('pth', 'mi', 'f')}
    onClick={() => { handlePageFavorite() }} >
    <Icon name={isPageFav ? 'star' : 'star outline'} />
  </div>


  const miItemCount = () => <div
    key={uniqueKey('pth', 'mi', 'ic')}>
    <Label circular color={'grey'}>{itemCount}</Label>
  </div>

  const miAction = () => {
    if (actionCaption) {
      console.log('a', actionCaption)
      return <div key={uniqueKey('pth', 'mi', 'ac')}><Label size={'mini'} circular color={itemLinked ? 'green' : 'grey'} onClick={() => { handleShowAction() }}>{actionCaption}</Label></div>
    } else {
      return <div key={uniqueKey('pth', 'mi', 'ac')}><Icon name={'check'} circular inverted color={itemLinked ? 'green' : 'grey'} onClick={() => { handleShowAction() }}></Icon></div>
    }
  }

  const miTitle = () => <LongPressWrapper longPressType={_longPressTypes.header}>
    <div
      className={'menu-title tmh-title'}
      key={uniqueKey('pth', 'mi', 't')}
      style={{ fontSize: fontSizes.title + 'rem' }}
    >
      <div style={{}}>{_main}</div>
      {_year && <div>{_year}</div>}
      {_sub && <div>{_sub}</div>}
      {breadcrumbs()}
    </div>
  </LongPressWrapper>

  const menuRight = () => {
    return <div className={'tmh-right'}>
      {itemCount && miItemCount()}
      {loggedIn && _showFavorite && miFavorite()}
      {/* {pushPayload && miPayload()} */}
      {allowItemLinking && miAction()}
      {loggedIn && <TopMenuIcons />}
    </div>
  }

  let includeBack = true

  switch (view) {
    case 'home':
    case 'clients':
    case 'events':
    case 'landing':
      if (otherView) {
        includeBack = true
      } else {
        includeBack = false
      }
      break;
    default:
      includeBack = true
  }

  const content = () => <div
    style={style}
    className={className}
  >
    {!includeBack && miSidebar()}
    {includeBack && miBackOrLogo()}
    {miTitle()}
    {menuRight()}
    {showPayload && seg_payload()}
  </div>

  if (showAction) {
    return <UiAppUserAction handleCancel={handleShowAction} itemLinked={itemLinked} />
  } else {
    return content()
  }
}

export default PageTopHeader